export const getStatusTagColor = (status: string): string | undefined => {
	const statusLower = status?.toLowerCase();

	switch (statusLower) {
		case 'sent':
			return 'processing';
		case 'delivered':
			return 'success';
		case 'bounced':
			return 'warning';
		case 'complaint':
			return 'warning';
		case 'failed':
			return 'error';
		case 'processed':
			return 'processing';
		default:
			return 'default';
	}
};
